import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    Image,
    StyleSheet
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib';

import img from '../../common/img';

import { pt, mta } from '../../common/utils';

class MovieInfo extends PureComponent {
    render() {
        const { movieInfo, scheduledPlay } = this.props;

        return (
            movieInfo
                ? <JDTouchable style={ st.movie_name_wrap }
                    onPress={ () => {
                        mta('MoCiInfoBanner', 'List', `${movieInfo.jSkuId}_${movieInfo.movieId}`);
                        this.context.router.toMovieDetail({ movieId: movieInfo.movieId, scheduledPlay });
                    } }
                >
                    <Image
                        blurRadius={ 10 }
                        style={ st.movie_name_bg }
                        resizeMode='cover'
                        source={ { uri: movieInfo.jdPicUrl } }
                    />
                    <View style={ st.movie_name }>
                        <View style={ st.text_img_wrap }>
                            <JDImage style={ st.movie_bg_img } source={ img.movie_bg } />
                            <JDText style={ st.movie_name_left }>{movieInfo.movieName}</JDText>
                        </View>
                        <View style={ st.text_img_wrap }>
                            <JDText style={ st.movie_name_right }>影片详情</JDText>
                            <JDImage style={ st.right_arrow } source={ img.right_arrow } />
                        </View>
                    </View>
                </JDTouchable>
                : null
        );
    }
}

const st = StyleSheet.create({
    movie_name_wrap: {
        position: 'relative',
        height: pt(60)
    },
    movie_name_bg: {
        width: pt(375),
        height: pt(60),
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    movie_name: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        // backgroundColor: 'rgba(0, 0, 0, 0.3)',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: pt(10)
    },
    text_img_wrap: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    movie_bg_img: {
        height: pt(18),
        width: pt(18),
        marginRight: pt(5)
    },
    right_arrow: {
        height: pt(12),
        width: pt(5),
        marginLeft: pt(5)
    },
    movie_name_left: {
        color: '#fff',
        fontSize: pt(16),
        backgroundColor: 'transparent'
    },
    movie_name_right: {
        color: '#fff',
        fontSize: pt(12),
        backgroundColor: 'transparent'
    }
});

MovieInfo.contextTypes = {
    router: PropTypes.object
};

export default MovieInfo;
